import { useEffect, useState } from "react";
import { Grid, Typography, TextField } from "@mui/material";
import { useIntl } from "react-intl";

import useEditedStyles from "../../../../hooks/useEditedStyles";
import { TemplateItemProps } from "../types";
import { EventRuleValue } from "./types";
import ZoneEvent from "../zoneevent/ZoneEvent";
import TimeTextField from "../TimeTextField";
import { onNumberInputClick } from "../../../../utils/utils";

interface EventRuleProps extends TemplateItemProps<EventRuleValue> {
  title: string;
  measUnit?: string;
  timeValue?: boolean;
}

const EventRule = ({ title, value, saved, onChange, disabled, measUnit, timeValue }: EventRuleProps) => {
  const [v, setV] = useState(`${value.v}` || "");
  const [events, setEvents] = useState({ alarm: value.e || "", recovery: value.r || "" });

  const { formatMessage } = useIntl();
  const editedStyle = useEditedStyles();

  useEffect(() => {
    setV(`${value.v}` || "");
    setEvents({ alarm: value.e || "", recovery: value.r || "" });
  }, [value]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="subtitle2">{title}</Typography>
      </Grid>
      <Grid item>
        {timeValue ? (
          <TimeTextField
            label={formatMessage({ defaultMessage: "Value" })}
            unit={1000}
            variant="filled"
            value={v}
            className={saved?.v !== parseInt(v, 10) ? editedStyle.input : ""}
            inputProps={{ min: 0, type: "number", onClick: onNumberInputClick }}
            onChange={(e) => setV(e.target.value)}
            onBlur={() => {
              if (v !== "") {
                value.v = parseInt(v, 10) || 0;
              } else {
                delete value.v;
              }
              onChange(value);
            }}
            color="secondary"
            sx={{ margin: 0 }}
            size="small"
            autoComplete="off"
            disabled={disabled}
            fullWidth
          />
        ) : (
          <TextField
            label={measUnit ? formatMessage({ defaultMessage: "Value ({measUnit})" }, { measUnit }) : formatMessage({ defaultMessage: "Value" })}
            variant="filled"
            value={v}
            className={saved?.v !== parseInt(v, 10) ? editedStyle.input : ""}
            inputProps={{ min: 0, type: "number", onClick: onNumberInputClick }}
            onChange={(e) => setV(e.target.value)}
            onBlur={() => {
              if (v !== "") {
                value.v = parseInt(v, 10) || 0;
              } else {
                delete value.v;
              }
              onChange(value);
            }}
            sx={{ minWidth: 140, width: 140, margin: 0 }}
            size="small"
            autoComplete="off"
            disabled={disabled}
          />
        )}
      </Grid>
      <ZoneEvent
        value={events}
        saved={saved ? { alarm: saved.e || "", recovery: saved.r || "" } : undefined}
        onChange={({ alarm, recovery }) => {
          setEvents({ alarm, recovery: recovery || "" });
          value.e = alarm;
          value.r = recovery || "";
          onChange(value);
        }}
        disabled={disabled}
        xs="auto"
      />
    </Grid>
  );
};

export default EventRule;
